//
//  I13VENTCHAUFGAZI18n.js
//
//  Created by Sébastien Hecart on 2017-11-24 14:11:01 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I13VENTCHAUFGAZ_SECTION_0_TITLE:
    'Calculez la taille de vos ventilations pour chaufferies gaz, et déterminez les dimensions en fonction de la forme géometrique souhaitée.',
  I13VENTCHAUFGAZ_in_puissanceTotal: 'Puissance Total',
  I13VENTCHAUFGAZ_in_dnConduitChemineTirage: 'Dn conduit cheminée',
  I13VENTCHAUFGAZ_in_surfaceChaufferie: 'Surface chaufferie',
  I13VENTCHAUFGAZ_SECTION_1_TITLE: 'Ventilation haute',
  I13VENTCHAUFGAZ_res_vhParoi: 'VH par paroi',
  I13VENTCHAUFGAZ_res_vh_gaine_ventilation: 'VH conduit',
  I13VENTCHAUFGAZ_SECTION_2_TITLE: 'Ventilation basse ',
  I13VENTCHAUFGAZ_res_VB_paroi: 'VB par paroi',
  I13VENTCHAUFGAZ_res_VB_conduite_mini: 'VB par conduit',
  I13VENTCHAUFGAZ_SECTION_3_TITLE: 'Géométrie des ouvertures',
  I13VENTCHAUFGAZ_res_VB_paroi_comburant: 'VB par paroi',
  I13VENTCHAUFGAZ_res_debit_VB: 'VB par conduit',
  I13VENTCHAUFGAZ_SECTION_4_TITLE: 'Section carrée par paroi',
  I13VENTCHAUFGAZ_res_longeurVH: 'Longueur VH',
  I13VENTCHAUFGAZ_res_longeurVB: 'Longueur VB',
  I13VENTCHAUFGAZ_res_vb_comburant: 'VB + comburant',
  I13VENTCHAUFGAZ_SECTION_5_TITLE: 'Section rectangulaire par paroi',
  I13VENTCHAUFGAZ_in_longeurVH: 'Longueur VH',
  I13VENTCHAUFGAZ_res_hauteurVH: 'Hauteur VH',
  I13VENTCHAUFGAZ_in_longeurVB: 'Longueur VB',
  I13VENTCHAUFGAZ_res_largeurVB: 'Largeur VB',
  I13VENTCHAUFGAZ_res_DIAMETRECALCUL: 'Diamètre à calculer',
  I13VENTCHAUFGAZ_res_DIAMETREVB: 'Diamètre VB',
  I13VENTCHAUFGAZ_res_diametreCirculaireVH: 'Diamètre VH',
  I13VENTCHAUFGAZ_res_diametreCirculaire: 'Diamètre VH',
  I13VENTCHAUFGAZ_res_diametreCirculaireVB: 'Diamètre VB'
}
